import type { BulkEditLoadingPhase } from "./bulk-edit-progress-overlay.component";

/** Full-screen bulk progress UI is only shown from this entry count upward. */
export const BULK_EDIT_PROGRESS_MIN_COUNT = 10;

export function shouldShowBulkEditProgress(entryCount: number): boolean {
	return entryCount >= BULK_EDIT_PROGRESS_MIN_COUNT;
}

export interface BulkEditLoadingState {
	percent: number;
	phase: BulkEditLoadingPhase;
}

/** Percent = processed / total; phase: 0% validating, 1–90% updating, >90% finalizing. */
export function bulkEditLoadingState(processed: number, total: number): BulkEditLoadingState {
	const percent = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;
	if (percent === 0) return { percent: 0, phase: "validating" };
	if (percent > 85) return { percent, phase: "finalizing" };
	return { percent, phase: "updating" };
}
